import { canAssignPortalPage } from "../../config/internalPortalPages";
import type { InternalAccess } from "./types";

export type InternalPortalPage = {
  key: string;
  superadminOnly?: boolean;
};

export function isPageAllowed(
  page: InternalPortalPage,
  access: InternalAccess,
): boolean {
  if (access.isSuperadmin) return true;
  if (!access.portalAccess || page.superadminOnly) return false;
  if (!access.pageKeys.includes(page.key)) return false;

  return canAssignPortalPage(page.key, access.role);
}

export function getAllowedPageKeys(
  pageKeys: string[],
  access: InternalAccess,
): string[] {
  return pageKeys.filter((key) => isPageAllowed({ key }, access));
}
